import { darkPalette as dark } from './dark';
import { lightPalette as light } from './light';

const Palette = { light, dark };

export default Palette;
